import React from 'react';
import Descriptions from 'antd/es/descriptions';
import { AuthenticatedContextType } from '../../context/AuthenticatedContext';

interface DataProps {
  userdata: AuthenticatedContextType;
}

const DataDisp: React.FC<DataProps> = ({ userdata }) => {
  const customerName = userdata.loginCustomer?.customerName ?? '';
  const corporateCode = userdata.loginCustomer?.corporateCode ?? '';

  const labelStyle: React.CSSProperties = {
    padding: '4px 8px',
    backgroundColor: '#e0e0e0',
    width: '150px',
    fontSize: '16px',
    textAlign: 'right' as const,
    fontWeight: 'bold' as const,
    whiteSpace: 'break-spaces', // 改行文字で改行するようになる(空白で突き抜けない)
    wordBreak: 'break-all', // はみだし対策（未解決）
  };

  const contentStyle: React.CSSProperties = {
    padding: '4px 8px',
    backgroundColor: '#fafafa',
    width: '300px',
    fontSize: '16px',
    whiteSpace: 'break-spaces', // 改行文字で改行するようになる(空白で突き抜けない)
    wordBreak: 'break-all', // はみだし対策（未解決）
  };

  return (
    <div style={{ width: '450px' }}>
      {/* ユーザ情報 */}
      <Descriptions
        bordered
        column={3}
        labelStyle={labelStyle}
        contentStyle={contentStyle}
        style={{
          marginTop: '54px',
          marginBottom: '10px',
        }}
      >
        <Descriptions.Item label="ユーザ名" span={3}>
          {`${corporateCode} ◇ ${customerName}`}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default DataDisp;
